"use client"

import { Button } from "@/components/ui/button"
import { motion } from "framer-motion"
import Link from "next/link"

export function ThanksgivingBanner() {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-accent text-accent-foreground py-3 px-4"
    >
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 text-center">
        <p className="text-sm sm:text-base font-semibold">
          🎉 We&apos;ve moved! Visit us at our new location: 102 Mill Street, Lockland, OH 45215
        </p>
        <Button
          asChild
          variant="secondary"
          size="sm"
          className="bg-background text-foreground hover:bg-background/90 font-semibold"
        >
          <Link href="/contact">Get Directions</Link>
        </Button>
      </div>
    </motion.div>
  )
}
